import AccordionItem from "components/DynamicComponent/atoms/AccordionItem"

export default function FAQSection({ blok }) {
  return (
    <section className="faq-section relative bg-teal-dark py-8">
      <h2 className="text-center text-l3 text-white lg:my-4 lg:mb-12 lg:text-xl1">{blok.heading}</h2>
      <div className="faq-section-container mx-auto max-w-screen-lg px-4 lg:px-0">
        {blok.items ? blok.items.map((item) => <AccordionItem blok={item} key={item._uid} />) : null}
      </div>
    </section>
  )
}
